export const APP_NAME = "Paces";
export const APP_ADMIN_NAME = "Paces Admin";

export const PAGE_META = {
    dashboard: {
        title: "Scan Dashboard",
        description: "Scan barcodes, review items, and save inventory scan slips.",
    },
    profile: {
        title: "User Profile",
        description: "View your account details and manage profile settings.",
    },
    upcScans: {
        title: "Scanned UPC Data",
        description: "Browse, filter, export, and manage saved UPC scan slips.",
    },
    inventoryLookup: {
        title: "Inventory Lookup",
        description: "Monthly inventory: book records vs physical scan count with over/short variance.",
    },
    analytics: {
        title: "Analytics & Forecasting",
        description: "Sales insights, demand forecasting, and smart reorder recommendations.",
    },
    purchaseRecords: {
        title: "Purchase Records",
        description: "Record goods received by UPC with manual entry or Excel import.",
    },
    saleRecords: {
        title: "Sale Records",
        description: "Record sales by UPC with manual entry or Excel import.",
    },
    exportExcel: {
        title: "Export Excel",
        description: "Generate Excel reports from your scanned UPC data.",
    },
    productCatalog: {
        title: "Product Catalog",
        description: "Search and manage your store price book and product pricing.",
    },
    addProduct: {
        title: "Add Product",
        description: "Add a single product to your store price book.",
    },
    importProducts: {
        title: "Import Products",
        description: "Bulk import products into your store price book from Excel.",
    },
    updateProduct: {
        title: "Update Product",
        description: "Edit product details, cost, and retail pricing.",
    },
    adminDashboard: {
        title: "Admin Dashboard",
        description: "Overview of stores, users, and master price book.",
        admin: true,
    },
    adminAnalytics: {
        title: "Analytics & Forecasting",
        description: "Cross-store performance, demand forecasting, and reorder insights.",
        admin: true,
    },
    storeManagement: {
        title: "Store Management",
        description: "Create, edit, and manage store locations.",
        admin: true,
    },
    userManagement: {
        title: "User Management",
        description: "Manage store users, roles, and menu permissions.",
        admin: true,
    },
    barcodeMapping: {
        title: "Barcode Mapping",
        description: "Manage case-to-item barcode mappings for scan resolution.",
        admin: true,
    },
    masterPriceBook: {
        title: "Master Price Book",
        description: "Global product catalog shared across all stores.",
        admin: true,
    },
    wholesalePriceBook: {
        title: "Wholesale Price Book",
        description: "Case and carton UPCs with quantities for inventory scanning.",
        admin: true,
    },
    login: {
        title: "Sign In",
        description: "Sign in to your Paces inventory management account.",
    },
    signup: {
        title: "Sign Up",
        description: "Create a new Paces inventory management account.",
    },
    verifyEmail: {
        title: "Verify Email",
        description: "Verify your email address to access your account.",
    },
    forgotPassword: {
        title: "Forgot Password",
        description: "Request a password reset link for your account.",
    },
    resetPassword: {
        title: "Reset Password",
        description: "Set a new password for your account.",
    },
    notFound: {
        title: "Page Not Found",
        description: "The page you are looking for could not be found.",
    },
};
